import Proptypes from 'prop-types'
import { useState } from 'react'
import { Helmet } from 'react-helmet'
import ReactHtmlParser from 'react-html-parser'

import { StyledText, StyledContainer } from './styles'

export const Text = ({ text }) => {

  if(text==null)return null

  const [ogDescription, setOgDescritpion] = useState(false)

  const getTmp = () => {
    if (!ogDescription) {
      setOgDescritpion(true)
      return (
        <Helmet>
          <meta property="og:description" content={text.split('\n')[0]} />
        </Helmet>
      )
    }
  }
  return (
    <StyledContainer>
      {getTmp()}
      <StyledText>{ReactHtmlParser(text)}</StyledText>
    </StyledContainer>
  )
}
Text.propTypes = {
  text: Proptypes.any,
}

export default Text
